const carouselSelectors = {
  carousel: '.js-carousel-slider',
  gridItem: '.js-carousel-item',
  arrows: '.js-carousel-arrows',
  prevButton: '.js-carousel-prev',
  nextButton: '.js-carousel-next',
};

const carouselAttributes = {
  disabled: 'disabled',
};

const carouselClasses = {
  hidden: 'hidden',
};

class CarouselSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  connectedCallback() {
    this.carousel = this.querySelector(carouselSelectors.carousel);
    this.items = this.querySelectorAll(carouselSelectors.gridItem);
    this.arrows = this.querySelector(carouselSelectors.arrows);
    this.prevButton = this.querySelector(carouselSelectors.prevButton);
    this.nextButton = this.querySelector(carouselSelectors.nextButton);

    if (!this.carousel || !this.items.length || !this.prevButton || !this.nextButton || !this.arrows) {
      console.error('CarouselSlider: Missing required elements.');
      return;
    }

    this.init();
  }

  disconnectedCallback() {
    // Cleanup observers and event listeners
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
    this.prevButton?.removeEventListener('click', this.handlePrevButtonClick.bind(this));
    this.nextButton?.removeEventListener('click', this.handleNextButtonClick.bind(this));
    this.carousel?.removeEventListener('scroll', this.updateButtons.bind(this));
  }

  init() {
    if (this.carousel) {
      this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
        root: this.carousel,
        threshold: 0.9,
      });

      this.intersectionObserver.observe(this.items[this.items.length - 1]);

      this.prevButton.addEventListener('click', this.handlePrevButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.handleNextButtonClick.bind(this));
      this.carousel.addEventListener('scroll', this.updateButtons.bind(this));

      this.resizeObserver = this.setResizeObserver();
      this.resizeObserver.observe(this.carousel);

      this.updateButtons();
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.nextButton.setAttribute(carouselAttributes.disabled, carouselAttributes.disabled);
        this.nextButton.setAttribute('aria-disabled', 'true');
      } else {
        this.nextButton.removeAttribute(carouselAttributes.disabled);
        this.nextButton.setAttribute('aria-disabled', 'false');
      }
    });
  }

  handlePrevButtonClick() {
    this.scrollCarousel('prev');
    setTimeout(this.updateButtons.bind(this), 300);
  }

  handleNextButtonClick() {
    this.scrollCarousel('next');
    setTimeout(this.updateButtons.bind(this), 300);
  }

  scrollCarousel(direction) {
    const currentScroll = this.carousel.scrollLeft;
    const itemWidth = this.items[0]?.clientWidth || 0;

    if (direction === 'next') {
      this.carousel.scrollTo({
        left: currentScroll + itemWidth,
        behavior: 'smooth',
      });
    } else {
      this.carousel.scrollTo({
        left: currentScroll - itemWidth,
        behavior: 'smooth',
      });
    }
  }

  updateButtons() {
    const currentScroll = this.carousel.scrollLeft;

    if (currentScroll <= 0) {
      this.prevButton.setAttribute(carouselAttributes.disabled, carouselAttributes.disabled);
      this.prevButton.setAttribute('aria-disabled', 'true');
    } else {
      this.prevButton.removeAttribute(carouselAttributes.disabled);
      this.prevButton.setAttribute('aria-disabled', 'false');
    }
  }

  setResizeObserver() {
    return new ResizeObserver(() => {
      const contentWidth = Array.from(this.items).reduce((acc, item) => acc + item.offsetWidth, 0);

      if (contentWidth > this.carousel.offsetWidth) {
        this.arrows.classList.remove(carouselClasses.hidden);
      } else {
        this.arrows.classList.add(carouselClasses.hidden);
      }
    });
  }
}

// const initializeCarouselSlider = () => {
//   if (!customElements.get('carousel-slider')) {
//     customElements.define('carousel-slider', CarouselSlider);
//   }
// };

customElements.get('carousel-slider') || customElements.define('carousel-slider', CarouselSlider);

// initializeCarouselSlider();
